import { ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { Box, theme } from '@mrshmllw/smores-react'

export const SPLIT_PAGE_TABLET_BREAKPOINT = 768
const SPLIT_PAGE_DESKTOP_BREAKPOINT = 1096

type SplitPageProps = {
  children: ReactNode
  asideContent: ReactNode
  hideContentOnMobile?: boolean
}

const SplitPage = ({ children, asideContent, hideContentOnMobile }: SplitPageProps) => {
  return (
    <Wrapper>
      <Background />
      <Container>{children}</Container>
      <AsideWrapper
        forwardedAs="aside"
        flex
        justifyContent="center"
        alignItems="center"
        $hideContentOnMobile={!!hideContentOnMobile}
      >
        {asideContent}
      </AsideWrapper>
    </Wrapper>
  )
}

export default SplitPage

const TABLET_GRID_TEMPLATE_COLUMNS = css`
  grid-template-columns: minmax(500px, 750px) minmax(250px, 100%);
`

const DESKTOP_GRID_TEMPLATE_COLUMNS = css`
  grid-template-columns: minmax(800px, 100%) minmax(250px, 100%);
`

const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 24px;
  height: calc(100% - 64px);

  @media (min-width: ${SPLIT_PAGE_TABLET_BREAKPOINT}px) {
    padding: 0;
    display: grid;
    ${TABLET_GRID_TEMPLATE_COLUMNS}
  }

  @media (min-width: ${SPLIT_PAGE_DESKTOP_BREAKPOINT}px) {
    ${DESKTOP_GRID_TEMPLATE_COLUMNS}
  }
`

const Background = styled.div`
  display: none;

  @media (min-width: ${SPLIT_PAGE_TABLET_BREAKPOINT}px) {
    z-index: 0;
    position: absolute;
    display: grid;
    width: 100vw;
    height: 100vh;
    top: 0;
    right: 0;
    ${TABLET_GRID_TEMPLATE_COLUMNS}

    &::before {
      content: '';
      height: 100%;
      width: 100%;
      top: 0;
      right: 0;
    }
    &::after {
      content: '';
      height: 100%;
      width: 100%;
      top: 0;
      right: 0;
      background-color: ${theme.colors.marshmallowPink};
    }
  }

  @media (min-width: ${SPLIT_PAGE_DESKTOP_BREAKPOINT}px) {
    ${DESKTOP_GRID_TEMPLATE_COLUMNS}
  }
`

const AsideWrapper = styled(Box)<{ $hideContentOnMobile: boolean }>`
  @media (min-width: ${SPLIT_PAGE_TABLET_BREAKPOINT}px) {
    padding: 40px 24px;
    z-index: 1;
  }
  @media (max-width: ${SPLIT_PAGE_TABLET_BREAKPOINT + 1}px) {
    ${({ $hideContentOnMobile }) =>
      $hideContentOnMobile &&
      css`
        display: none;
      `}
  }
`

const Container = styled(Box)`
  z-index: 1;
  @media (min-width: ${SPLIT_PAGE_TABLET_BREAKPOINT}px) {
    max-width: 750px;
    justify-self: center;
    padding: 64px;
    align-self: center;
    padding: 64px 24px;
  }

  @media (min-width: ${SPLIT_PAGE_DESKTOP_BREAKPOINT}px) {
    padding: 64px;
  }
`
